import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from 'react-query';


export const useDeleteLcrWorksheetMacro = (
  crId, lcrId, worksheetId,
) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  return useMutation(
    (liveCleanRoomWorksheetMacroID) => axiosInstance.delete(liveCleanroom(orgId)
      .deleteWorksheetMacro(crId, lcrId, worksheetId, liveCleanRoomWorksheetMacroID)),
    {
      onSuccess: () => {
        dispatch(
          showAlert({
            message: 'Macro deleted successfully',
            type: 'success',
          }),
        );
      },
      onError: (error) => {
        dispatch(
          showAlert({
            message: error.response?.data?.message || 'Error deleting macro',
            type: 'error',
          }),
        );
      },
    },
  );
};
